import { EntityRequest, SubstrateSearchRequest } from '../schema/SubstrateSearchRequest';
import { Mini3SScenario } from '../schema/SubstrateScenarios';
import { UTC_TIMEZONE } from './constants';

/**
 * Create a SubstrateSearchRequest object from searchSessionId and entityRequests array
 * @param searchSessionId
 * @param entityRequests
 */
export const createSubstrateSearchRequest = (
    searchSessionId: string,
    logicalId: string,
    entityRequests: EntityRequest[]
): SubstrateSearchRequest => ({
    Cvid: searchSessionId,
    LogicalId: logicalId,
    EntityRequests: entityRequests,
    Scenario: {
        Name: Mini3SScenario.MINI_SEARCH_SCENARIO_NAME,
    },
    TimeZone: UTC_TIMEZONE,
});
